module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "header-new fixed-dom"
  }, [_vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "jumpLogin",
    attrs: {
      "to": "login"
    }
  }, [_vm._v("管理系统")])], 1), _vm._v(" "), _c('div', {
    staticClass: "nav"
  }, [_c('ul', [_vm._l((2), function(n) {
    return [_c('li', [_c('div', {
      staticClass: "navitem",
      class: n == _vm.activeNum ? 'activeNavItem' : ''
    })])]
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    ref: "scrollOne",
    staticClass: "page page-one actived"
  }), _vm._v(" "), _c('div', {
    ref: "scrollTwo",
    staticClass: "page page-two actived"
  })]), _vm._v(" "), _c('div', {
    staticClass: "layout-footer-center"
  }, [_c('p', {
    staticClass: "footer-font"
  }, [_vm._v("\n      Copyright © 2022 北京海阅天成科技有限公司 All Rights Reserved.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "btnFlex"
  }, [_c('p', {
    staticClass: "footer-font"
  }, [_vm._v("\n        备案号：\n        "), _c('a', {
    staticClass: "footer-font",
    attrs: {
      "target": "_blank",
      "rel": "nofollow",
      "href": "https://beian.miit.gov.cn"
    }
  }, [_vm._v(_vm._s(_vm.beianNum))])]), _vm._v(" "), _vm._m(1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layout-logo"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/logosadd.png"),
      "width": "380px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "footer-font toBa"
  }, [_c('a', {
    staticClass: "footer-font",
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502048252"
    }
  }, [_vm._v("京公网安备 11010502048252号")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b1640de","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/index.vue
// module id = 717
// module chunks = 1